<template>
  <!-- HEADER整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/index/logo_name.png" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0" class="header-nav-item">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/index/logo_name.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data () {
    return {
      navIndex: sessionStorage.getItem('navIndex')
        ? sessionStorage.getItem('navIndex')
        : 0,
      menuName: '首页',
      menuClass: 'glyphicon glyphicon-menu-down',
      navList: [
        {
          name: '首页',
          path: '/',
          children: []
        },
        {
          name: '信息公告',
          path: '/announcement',
          children: []
        },
        {
          name: '解决方案',
          path: '/solution',
          children: [
            {
                path: '/solution/oneRealData',
                name: '实时数据平台'
            },
            {
                path: '/solution/productionMonitor',
                name: '油气生产监控系统'
            },
            {
                path: '/solution/intelligentAlarm',
                name: '油气生产智能预警系统'
            },
            {
                path: '/solution/iotDeviceDiagnosis',
                name: '物联网设备在线诊断系统'
            },
            {
                path: '/solution/energyControl',
                name: '能源管控平台'
            },
            {
                path: '/solution/productionReport',
                name: '生产报表管理系统'
            }
          ]
        },
        {
          name: '客户案例',
          path: '/cases',
          children: []
          // children: [
          //   {
          //     name: '厂级生产运行监控系统',
          //     path: '/cases/OilProductionMonitor'
          //   },
          //   {
          //     name: '能源管控一体化平台',
          //     path: '/cases/EnergyManage'
          //   },
          //   {
          //     name: '物联网安全生产监控系统',
          //     path: '/cases/IOTMonitor'
          //   },
          //   {
          //     name: '智能生产调度系统',
          //     path: '/cases/IntelligentDispatching'
          //   }
          // ]
        },
        {
          name: '核心产品',
          path: '/software',
          children: [
            {
                path: '/software/DATimsien',
                name: '天行实时数据平台',
                id:'DATimsien'
            },
            {
                path: '/software/TimMonitor',
                name: '天行智能生产监控系统',
                id:'TimMonitor'
            },
            {
                path: '/software/TimRiver',
                name: '天河流式计算引擎',
                id:'TimRiver'
            },
            {
                path: '/software/DMS',
                name: '数据管理系统',
                id:'TimDMS'
            }
          ]
        },
        {
          name: '关于我们',
          path: '/company',
          children: []
        }
      ],
      logo_img: [
        {
          path: require('../assets/img/index/logoWhite.png')
        },
        {
          path: require('../assets/img/index/logo_name.png')
        }
      ]
    }
  },
  methods: {
    navClick (index, name) {
      this.navIndex = index
      sessionStorage.setItem('navIndex', index)
      this.menuName = name
    },
    menuClick () {
      if (this.menuClass === 'glyphicon glyphicon-menu-down') {
        this.menuClass = 'glyphicon glyphicon-menu-up'
      } else {
        this.menuClass = 'glyphicon glyphicon-menu-down'
      }
    }
  }
}
</script>

<style scoped>
/* 顶部 */
#header {
  /* background: #f4f4f4; */
  transition: all ease 0.6s;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 200px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 20px;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}

#header .header-nav .header-nav-item{
  line-height: 50px;
  float: right;
  margin: 0;
  max-width: 800px;
}

#header .header-nav .header-nav-item > dt > a {
  color: #000;
}
#header .header-nav .header-nav-item > dt > a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #444;
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 16px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 188px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 200px;
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 16px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue